import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { string } from "yup";
// import uuid from 'react-uuid'
import { store } from "../app/store";
import {
  MemberData,
  IOldMemberhasDisease,
  PolicyDetails,
  ProposerData,
  Salutation,
} from "../Interfaces/general";


export type IProposerField = 'course_name'| 'passing_year' | 'email'
export interface IState {
  members: MemberData[];
  proposer: ProposerData;
  // policy1deductible7lac: false;
  // policy2deductible7lac: false;
  // policy3deductible7lac: false;

  oldMemberhasDisease: IOldMemberhasDisease;
  policyDetails: {
    policy1Data: PolicyDetails | null;
    policy2Data: PolicyDetails | null;
    policy3Data: PolicyDetails | null;
    policy4Data: PolicyDetails | null;
  };
  orderID: string;
  authToken: string;
  isPaymentModalOpen: boolean;
  id: string;
  isGPAAdded: boolean;
  isNewUser: boolean;
  nomineeName: string;
  nomineeRelationship: string
  nomineeDob: string
  leadUID: string
  disabledProposerFields: IProposerField[]
  panNumber:string
}

const initialState: IState = {
  members: [],
  proposer: {
    firstName: "",
    lastName: "",
    middleName: "",
    salutation: "Mr",
    // age: "",
    dob: "",
    rollNumber: "",
    phoneNumber: "",
    course: "",
    passingYear: "",
    pincode: "",
    cityName: "",
    stateName: "",
    stateDisplayName: "",
    address: "",
    address2:"",
    code: "",
    userId: "",
  },
  policyDetails: {
    policy1Data: {
      id: "1",
      sumInsured: "",
      deductible: "",
      premium: "",
      premiumWithGST: "",
    },
    policy2Data: null,
    policy3Data: null,
    policy4Data: null,
  },
  oldMemberhasDisease: {
    self: {
      hasDisease: false,
      diseaseList: [],
      isIncluded: false,
    },
    spouse: {
      hasDisease: false,
      isIncluded: false,
      diseaseList: [],
    },
    father: {
      hasDisease: false,
      isIncluded: false,
      diseaseList: [],
    },
    mother: {
      hasDisease: false,
      isIncluded: false,
      diseaseList: [],
    },
    "father-in-law": {
      hasDisease: false,
      isIncluded: false,
      diseaseList: [],
    },
    "mother-in-law": {
      hasDisease: false,
      isIncluded: false,
      diseaseList: [],
    },
    son: {
      hasDisease: false,
      isIncluded: false,
      diseaseList: [],
    },
    daughter: {
      hasDisease: false,
      isIncluded: false,
      diseaseList: [],
    },
  },
  isPaymentModalOpen:false,
  orderID: "",
  authToken: "",
  id: "",
  isGPAAdded: false,
  isNewUser: false,
  nomineeDob: '',
  nomineeName: '',
  nomineeRelationship: '',
  leadUID: '',
  disabledProposerFields: [],
  panNumber:''
};

const membersSlice = createSlice({
  name: "members",
  initialState: initialState,
  reducers: {
    updateMembersStoreData: (state, action: PayloadAction<{
      members: MemberData[];
      proposer: ProposerData;
      policyDetails: {
        policy1Data: PolicyDetails | null;
        policy2Data: PolicyDetails | null;
        policy3Data: PolicyDetails | null;
        policy4Data: PolicyDetails | null;
      };
      nomineeName: string;
      nomineeRelationship: string
      nomineeDob: string;
      leadUID: string
      panNumber: string
    }>) => {
      state.members = action.payload.members;
      state.proposer = action.payload.proposer;
      state.policyDetails = action.payload.policyDetails;
      state.nomineeName = action.payload.nomineeName;
      state.nomineeRelationship = action.payload.nomineeRelationship;
      state.nomineeDob = action.payload.nomineeDob;
      state.leadUID = action.payload.leadUID;
      state.panNumber = action.payload.panNumber
    },
    updateUserStatus: (state, action: PayloadAction<boolean>) => {
      state.isNewUser = action.payload;
    },
    updatePaymentModalStatus: (state, action: PayloadAction<boolean>) => {
      state.isPaymentModalOpen = action.payload;
    },
    updateIsGPAAdded: (state, action: PayloadAction<boolean>) => {
      state.isGPAAdded = action.payload;
    },
    updatePolicyDetails: (
      state,
      action: PayloadAction<{
        type: "policy1Data" | "policy2Data" | "policy3Data" | "policy4Data";
        data: PolicyDetails | null;
      }>
    ) => {
      state.policyDetails[action.payload.type] = action.payload.data;
    },

    changeID: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetMembers: () => initialState,
    resetPolicyDetails: (state) => {
      state.policyDetails.policy1Data = {
        deductible: "",
        id: "",
        premium: "",
        sumInsured: "",
        coverForChildren: "",
        coverForSpouse: "",
        premiumWithGST: "",
      };
      state.policyDetails.policy2Data = null;
      state.policyDetails.policy3Data = null;
      state.policyDetails.policy4Data = null;
    },
    removeMemberPrexistingDiseases: (state) => {
      state.members.forEach((member) => {
        member.haspreExistingDiseases = false;
        member.preExistingDiseasesList = [];
      });
    },
    removeMemberLifeStyleInfo: (state) => {
      state.members.forEach((member) => {
        member.haslifestyleQuestions = false;
        member.lifestyleQuestions = [];
      });
    },
    removeMembers: (state) => {
      state.members = [];
    },
    addMember: (state, action: PayloadAction<MemberData>) => {
      let arr = state.members;
      arr.push(action.payload);
      state.members = arr;
    },
    removeMember: (state, action: PayloadAction<string>) => {
      state.members = state.members.filter(
        (member) => member.code !== action.payload
      );
    },
    editMemberDetails: (
      state,
      action: PayloadAction<{
        code: string;
        memberData: {
          firstName?: string;
          lastName?: string;
          middleName?: string;
          age?: string;
          dob?: string;
          haspreExistingDiseases?: boolean;
          preExistingDiseases?: string[];
          haslifestyleQuestions?: boolean;
          lifestyleQuestions?: string[];
          perMemberPremium?: string;
          perMemberPremiumWithGST?: string;
          gpaPerMemberPremium?: string;
          gpaPerMemberPremiumWithGST?: string;
          gender?: string;
          preExistingDiseasesList?: string[];
          isHospitalized?: string;
          doesConsumeAlcohol?: string;
          otherPEDs?: string;
          isMemberEligible?: boolean;
        };
      }>
    ) => {
      let tempMembers: MemberData[] = [];
      state.members.forEach((member) => {
        if (member.code === action.payload.code) {
          member = {
            ...member,
            ...action.payload.memberData,
          };
          tempMembers.push(member);
        } else {
          tempMembers.push(member);
        }
      });
      state.members = tempMembers;
    },
    updateProposerData: (state, action: PayloadAction<ProposerData>) => {
      state.proposer = action.payload;
    },
    updateOrderID: (state, action: PayloadAction<string>) => {
      state.orderID = action.payload;
    },
    updateAuthToken: (state, action: PayloadAction<string>) => {
      state.authToken = action.payload;
    },
    removeByMemberType: (
      state,
      action: PayloadAction<
        | "self"
        | "spouse"
        | "daughter"
        | "son"
        | "father"
        | "mother"
        | "father-in-law"
        | "mother-in-law"
      >
    ) => {
      state.members = state.members.filter(
        (member) => member.type !== action.payload
      );
    },
    updatePreviousPolicyMemberHavingDisease: (state, action: PayloadAction<IOldMemberhasDisease>) => {
      state.oldMemberhasDisease = { ...state.oldMemberhasDisease, ...action.payload }
    },
    clearPreviousPolicyMemberHavingDisease: (state) => {
      state.oldMemberhasDisease = initialState.oldMemberhasDisease
    },
    updateNomineeData: (state, action: PayloadAction<{
      nomineeName: string;
      nomineeRelationship: string
      nomineeDob: string
    }>) => {
      state.nomineeName = action.payload.nomineeName
      state.nomineeDob = action.payload.nomineeDob
      state.nomineeRelationship = action.payload.nomineeRelationship

    },
    updateLeadUID: (state, action: PayloadAction<{
      uid: string
    }>) => {
      state.leadUID = action.payload.uid
    },
    updateDisabledProposerFields: (state, action: PayloadAction<IProposerField[]>) => { 
      state.disabledProposerFields=[...state.disabledProposerFields, ...action.payload]
    },
    clearDisabledProposerFields: (state) => { 
      state.disabledProposerFields=[]
    },
    updatePanNumber: (state, action:PayloadAction<string>) => { 
      state.panNumber = action.payload
    }
  },
});

const { reducer } = membersSlice;

export const {
  resetMembers,
  addMember,
  removeMember,
  editMemberDetails,
  updateProposerData,
  removeMembers,
  removeMemberPrexistingDiseases,
  removeMemberLifeStyleInfo,
  updatePolicyDetails,
  resetPolicyDetails,
  updateOrderID,
  removeByMemberType,
  updateAuthToken,
  changeID,
  updateIsGPAAdded,
  updateUserStatus,
  updatePreviousPolicyMemberHavingDisease,
  clearPreviousPolicyMemberHavingDisease,
  updateNomineeData,
  updateLeadUID,
  updateDisabledProposerFields,
  clearDisabledProposerFields,
  updatePanNumber,
  updateMembersStoreData,
  updatePaymentModalStatus
} = membersSlice.actions;

export { reducer as membersReducer };
